<mat-form-field
  appearance="outline"
  [floatLabel]="floatLabel"
>
  <mat-label *ngIf="label"> {{ label }} </mat-label>

  <mat-select
    (selectionChange)="onOptionSelected($event)"
    [attr.disabled]="isDisabled"
    [formControl]="control"
  >
    <mat-option
      *ngIf="noSelection"
      [value]="null"
    >
      -- None --
    </mat-option>

    <mat-option
      *ngFor="let item of options"
      [value]="item.key"
      [disabled]="item.count !== undefined && item.count <= 0"
    >
      <div class="flex-option">
        <span>
          <span
            *ngIf="item.isChild"
            style="padding-right: 1rem"
          >
            -
          </span>

          {{ item.value }}
        </span>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
